/**
 * CELLHACK homepage sections: reviews carousel, quiz-teaser option
 * selection (cosmetic only — this is a teaser, not the real quiz) and the
 * FAQ accordion (single-open, first item open by default from the server
 * render in sections/home-faq-signup.liquid). Origin-teaser pins are
 * static and need no JS. Add-to-cart buttons use `data-ch-add`, handled
 * globally by assets/cellhack-cart.js — nothing to wire up here.
 */
(function () {
  // Reviews carousel ---------------------------------------------------------
  document.querySelectorAll('[data-ch-reviews-track]').forEach((track) => {
    const section = track.closest('.ch-reviews') || track.parentElement;
    const prevBtn = section && section.querySelector('[data-ch-reviews-prev]');
    const nextBtn = section && section.querySelector('[data-ch-reviews-next]');

    function scroll(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', () => scroll(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => scroll(1));
  });

  // FAQ accordion (single-open per group) ------------------------------------
  document.querySelectorAll('[data-ch-faq-accordion]').forEach((group) => {
    const items = Array.from(group.querySelectorAll('[data-ch-faq-item]'));
    items.forEach((item) => {
      const trigger = item.querySelector('[data-ch-faq-trigger]');
      const answer = item.querySelector('[data-ch-faq-answer]');
      const icon = item.querySelector('[data-ch-faq-icon]');
      if (!trigger || !answer) return;

      trigger.addEventListener('click', () => {
        const isOpen = !answer.hidden;
        items.forEach((other) => {
          const otherAnswer = other.querySelector('[data-ch-faq-answer]');
          const otherTrigger = other.querySelector('[data-ch-faq-trigger]');
          const otherIcon = other.querySelector('[data-ch-faq-icon]');
          if (otherAnswer) otherAnswer.hidden = true;
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherIcon) otherIcon.textContent = '+';
        });
        if (!isOpen) {
          answer.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          if (icon) icon.textContent = '−';
        }
      });
    });
  });
})();
